import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/PeticionMaterial/peticionmaterial';
import PeticionForm from './peticionMaterial';

const mstp = state => {
    return {...state.peticionM}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(PeticionForm)
